import { SBaseDisplay, SDate } from '@summit/core';

import { SummitFormattedText } from '@summit/models';
import { EboObject } from '../base-classes/ebo-object';
import { Hub } from '../places/hub/hub';
import { TruckAliasLinehaulRunAssignment } from '../truck/truck-alias-linehaul-run-assignment';
import { LinehaulRunDetail } from './linehaul-run-detail';
import { RouteLinehaulAssignment } from './route-linehaul-assignment';

export class LinehaulRun extends EboObject implements SBaseDisplay {
  originHubID: number;
  originHub: Hub;
  destHubID: number;
  destHub: Hub;
  laneDestinationHubID: number;
  laneDestinationHub: Hub;
  status: string;
  run: number;
  details: LinehaulRunDetail[];
  aliasRunAssignments: TruckAliasLinehaulRunAssignment[];
  routeAssignments: RouteLinehaulAssignment[];

  constructor(jsonData: Partial<LinehaulRun>) {
    super(jsonData);
    if (jsonData.originHub) {
      this.originHub = new Hub(jsonData.originHub);
    }
    if (jsonData.destHub) {
      this.destHub = new Hub(jsonData.destHub);
    }
    if (jsonData.originHub) {
      this.laneDestinationHub = new Hub(jsonData.laneDestinationHub);
    }
    if (jsonData.details) {
      this.details = jsonData.details
        .map((data) => new LinehaulRunDetail(data))
        .sort((a, b) => {
          if (a?.altWeek == b?.altWeek) return a?.leg - b?.leg;
          return a?.altWeek - b?.altWeek;
        });
    } else {
      this.details = new Array<LinehaulRunDetail>();
    }
    if (jsonData.aliasRunAssignments) {
      this.aliasRunAssignments = jsonData.aliasRunAssignments.map((data) => new TruckAliasLinehaulRunAssignment(data));
    } else {
      this.aliasRunAssignments = new Array<TruckAliasLinehaulRunAssignment>();
    }
    if (jsonData.routeAssignments) {
      this.routeAssignments = jsonData.routeAssignments.map((data) => new RouteLinehaulAssignment(data));
    } else {
      this.routeAssignments = new Array<RouteLinehaulAssignment>();
    }
  }

  private _routeSummary: SummitFormattedText;
  get routeSummary(): SummitFormattedText {
    if (!this._routeSummary) {
      const response = new SummitFormattedText();
      this.routeAssignments
        ?.filter((item) => !item.endTime || item.endTime.isSameOrAfter(SDate.new()))
        .forEach((item) => {
          response.AddLine(item.toShortString('RouteOnly'), null, { path: ['/routes', item.routeID] });
        });
      this._routeSummary = response.isEmpty() ? null : response;
    }
    return this._routeSummary;
  }

  get defaultSort(): string {
    return this.toShortString();
  }

  toShortString(): string {
    let lclStatus = this.status;
    switch (lclStatus) {
      case 'Assigned':
      case 'Unassigned':
      case 'TempAssign':
        lclStatus = lclStatus.slice(0, 1);
        break;
      default:
        break;
    }
    return `${lclStatus}:${this.originHubID}->${this.destHubID}|>${this.laneDestinationHubID}:R${
      this.run
    } [${this.id.slice(-4)}]`;
  }

  get shortStringName(): string {
    return this.toShortString();
  }
}
